/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

const mock = [
  
];

const Larq = () => {
  const theme = useTheme();
  return (
    <Box>
      <Grid container spacing={4}>
        <Grid item xs={16} md={6}>
          <Box>
            <Typography variant={'h4'} gutterBottom sx={{ fontWeight: 800 }}>
            OUR CORE VALUES
            </Typography>
            <Typography  component={'p'} color={'text.secondary'} align='justify'>
            Children First : We place the interests of the children to awaken joy in their creative expression.
              <br />
              Collaborative Partnership : We foster a strong relationship with parents and associates.
              <br />
              Culture of Excellence : We strive for excellence in holistic development of each child.
              <br />
              Professional Conduct : We hold the highest standard of integrity and treat everybody with respect and dignity.
              <br />
              Community Spirit : We inculcate a strong sense of unity along with community spirit in our students.
            </Typography>
          </Box>
          
        </Grid>
        <Grid item xs={12} md={6}>
          <Box>
            <Typography variant={'h4'} gutterBottom sx={{ fontWeight: 800 }}>
            OUR CURRICULUM
            </Typography>
            <Typography component={'p'} color={'text.secondary'} align='justify'>
            Our indigenous curriculum fosters a supportive and responsive environment for the holistic development of children with commitment, love and respect.
              <br />
              We believe that every child is a unique, competent and capable individual, with innovative ideas, unique talents, and unlimited possibilities for change and growth that must be nurtured, encouraged and developed to his or her fullest potentia.
              <br />
              We believe that early childhood education should foster holistic development, to serve as the foundation for intellectual growth and development.
              <br />
              We believe that early childhood education should nurture life skills, and promote inquisitiveness in children to make them lifelong learners who have positive dispositions, attitudes and feelings towards learning.
              <br />
              We recognize and support the areas of development in children by promoting meaningful and collaborative partnership and making them independent.
            </Typography>
          </Box> 
        </Grid>
      </Grid>
    </Box>
    
  );
};


export default Larq;
